import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e5daba4a")

_pushScopeId("data-v-e5daba4a")
const _hoisted_1 = { class: "SRadioButtons" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close_white = _resolveComponent("icon-close-white")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
      return (_openBlock(), _createBlock("div", {
        class: "SRadioButtons__button__wrapper",
        key: `${i}-${option}`
      }, [
        _createVNode("button", {
          class: ["SRadioButtons__button", { active: i === _ctx.activeValueIndex, canunselect: _ctx.canUnselect }],
          type: "button",
          onClick: ($event: any) => (_ctx.selectOption(option, i))
        }, [
          (_ctx.canUnselect)
            ? (_openBlock(), _createBlock(_component_icon_close_white, {
                key: 0,
                class: "SRadioButtons__button__icon"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(option.name), 1)
        ], 10, ["onClick"])
      ]))
    }), 128))
  ]))
})